import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import BuyPackagesModal from "../Components/Modals/BuyPackagesModal";
import { analyticsEvents } from '../../services/firebase/analytics-events.service';
type Props = NativeStackScreenProps<RootStackParamList, "BuyPackages">;

const ProfileScreen: React.FC<Props> = ({ navigation, route }) => {
  return <BuyPackagesModal onClose={() => navigation.goBack()} route={route} />;
};

export default ProfileScreen;
